// personCards JS, for content block in new theme 
// datarobot6/views/gutenberg/content/dr-person-cards.twig

document.addEventListener('DOMContentLoaded', () => {
	
  // Check if at least one expanded card exists
  const expandedCards = document.querySelectorAll('.personCards__card.-expanded');
  
  // If no expanded cards are found, exit the script
  if (expandedCards.length === 0) {
    return;
  }

  const openButtons = document.querySelectorAll('.personCards__card');
  const overlay = document.querySelector('.personCards__popupOverlay');

  // Function to open the popup and lock scrolling
  function openPopup(popup) {
    if (popup) {
      popup.classList.add('-popupActive');
      overlay.classList.add('-overlayActive');

      // Lock the scroll on both body and html
      document.documentElement.style.overflow = 'hidden'; // Lock the scroll on <html>
    }
  }

  // Function to close the popup and unlock scrolling
  function closePopup() {
    const activePopup = document.querySelector('.personCards__popup.-popupActive');
    if (activePopup) {
      activePopup.classList.remove('-popupActive');
    }
    overlay.classList.remove('-overlayActive');

    // Unlock the scroll on <html>
    document.documentElement.style.overflow = ''; // Unlock the scroll on <html>
  }

  // Event listeners for opening each popup
  openButtons.forEach((button) => {
    const card = button.closest('.personCards__card');
    const popup = card.querySelector('.personCards__popup');

    button.addEventListener('click', () => {
      openPopup(popup);
    });
  });

  // Event listeners for closing the popup via close button and overlay
  document.addEventListener('click', (event) => {
    if (event.target.matches('.personCards__popupClose') || event.target === overlay) {
      closePopup();
    }
  });

  // console.log("popup load test");
});

